import { SingleCensusType } from "types";

function validateMember(emp: SingleCensusType): boolean {
  const info = emp.employeeInformation;

  if (!emp.firstName || !emp.lastName || !emp.email) {
    return false;
  }

  if (!info) {
    return false;
  }

  if (!info.title || !info.roleDescription) {
    return false;
  }

  if (info.isRemote === true) {
    if (!info.remoteAddress) {
      return false;
    }
  } else if (info.isRemote === false) {
    if (!emp.officeLocationId) {
      return false;
    }
  }

  if (emp.isCompanyOwner === true) {
    if (info.ownerStake == null) {
      return false;
    }
  } else if (emp.isCompanyEmployee === true) {
    if (info.adminAccess === undefined || info.adminAccess === null) {
      return false;
    }
    if (!emp.employeeType) {
      return false;
    }
  }

  if (info.isPaid === "Paid") {
    if (!info.exemptionStatus) {
      return false;
    }

    if (!info.salaryType) {
      return false;
    }

    if (info.salaryType === "Hourly rate") {
      if (!info.hourlyRate) {
        return false;
      }
      if (!info.hoursWeekly) {
        return false;
      }
    } else if (info.salaryType === "Annual salary") {
      if (!info.salary) {
        return false;
      }
    }
  }
  return true;
}

export { validateMember };
